import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    underLine: { textDecoration: 'underline' },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    alignFlexStart: {
      alignItems: 'flex-start'
    },
    taskCountsLeft: {
      marginRight: 30
    },
    textAlignRight: {
      textAlign: 'right',
      justifyContent: 'flex-end'
    },
    justifyRight: {
      justifyContent: 'right'
    },
    firstRowRight: {
      marginLeft: 20
    },
    containerPadding: {
      padding: '15px'
    },
    gridContainerPadding: {
      '@media screen and (min-width:600px)': {
        padding: 15
      }
    },
    gridContainerBackgroundColor: {
      backgroundColor: '#FFFFFF'
    },
    gridFirstRow: {
      marginBottom: 10
    },
    ProcessSelectfieldWidth: {
      '@media screen and (min-width:600px)': {
        width: '100%'
      },
      '@media screen and (max-width:600px)': {
        width: '90%'
      }
    },
    displayContainer: {
      backgroundColor: '#FFFFFF',
      marginTop: '15px'
    },
    chartContainer: {
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    },
    InsertChartIconTransform: {
      transform: 'rotate(90deg)'
    },
    // 工程追加アイコン
    createNewFolderIcon: {
      fontSize: '36px',
      color: 'white',
      backgroundColor: '#666666',
      border: '6px solid #666666',
      borderRadius: '4px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    // Excel出力アイコンセット
    iconContainer: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    insertDriveFileIcon: {
      fontSize: '36px',
      color: 'white',
      backgroundColor: '#666666',
      border: '6px solid #666666',
      borderRadius: '4px',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1
    },
    forwardIcon: {
      fontSize: '13px',
      color: 'white',
      backgroundColor: '#666666',
      border: '0px solid #666666',
      borderRadius: '100px',
      position: 'absolute',
      bottom: 5,
      right: 4,
      zIndex: 2
    },
    // ここまでExcel出力アイコンセット
    taskAlertWrapper: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    textInfoWrapper: {
      padding: 5
    },
    buttonWrapper: {
      paddingRight: 5
    },
    displayModeButtonWrapper: {
      width: 230
    },
    // displayModeButtonWrapperのwidthを引く
    displayIconButtonWrapper: {
      width: 'calc(100% - 230px)'
    },
    excelButton: {
      minWidth: '105px'
    },
    constructDateWrapper: {
      width: '560px',
      textAlign: 'center',
      marginLeft: 10
    },
    constructDateCell: {
      border: '1px solid #CCCCCC',
      borderRight: 'none',
      fontSize: '14px',
      padding: '6px',
      height: 34
    },
    constructDateCellMobile: {
      border: '1px solid #CCCCCC',
      borderRight: 'none',
      padding: '2px 6px',
      fontSize: '0.8rem'
    },
    constructDateCellMobileContainer: {
      display: 'flex',
      width: '100%'
    },
    constructDateTitleCell: {
      backgroundColor: '#EFEFEF',
      padding: '6px 12px'
    },
    constructDateCellEnd: {
      borderRight: '1px solid #CCCCCC'
    },
    constructTotalDaysLabel: {
      width: 60
    },
    constructDateLabel: {
      width: 130
    },
    constructTotalDaysMoblie: {
      width: 90
    },
    constructDateMobile: {
      width: 'calc((100% - 90px)/2)'
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      position: 'relative',
      left: 10
    },
    leftSideButtonsContainer: {
      display: 'flex',
      paddingRight: '5px',
      height: '36px',
      minWidth: '150px',
      justifyContent: 'flex-end'
    },
    editButtonSubstitute: {
      minWidth: '74px'
    },
    buttonsBorderLine: {
      borderLeft: '2px solid gray',
      height: '36px',
      paddingRight: '10px'
    },
    buttonsContainerForMobile: {
      display: 'flex',
      alginItems: 'flex-end',
      width: '100%'
    },
    customerNameMoblie: {
      marginTop: '8px'
    },
    moreVert: {
      padding: '0 !important',
      marginLeft: 'auto',
      position: 'relative',
      top: 2,
      cursor: 'pointer'
    },
    moreVertMenuButton: {
      padding: '6px 16px !important'
    },
    moreVertMenuBorder: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
    },
    inlineButton: {
      margin: '5px 0px'
    },
    inlineButtonAdjust: {
      position: 'relative',
      top: -5
    },
    loadingContainer: {
      height: 650,
      backgroundColor: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    },
    disabledAddButton: {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        cursor: 'not-allowed'
      }
    },
    disabledAddIcon: {
      opacity: 0.1
    },
    updateDateResponsive: {
      marginBottom: 8,
      fontSize: 12,
      textAlign: 'right'
    }
  })
);
